import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getInvoiceDetails, updateInvoiceStatus } from "../../services/invoice.service";
import moment from "moment";
import Swal from "sweetalert2";

function InvoiceDetail() {
  const [searchParams] = useSearchParams();
  const invoiceId = searchParams.get("id");

  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔹 Fetch Invoice Details
  const fetchInvoiceDetails = async () => {
    try {
      const resp = await getInvoiceDetails(invoiceId);


      if (resp.success) {
        setInvoice(resp.data);
      }
    } catch (error) {
      console.error("Invoice detail error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (invoiceId) {
      fetchInvoiceDetails();
    }
  }, [invoiceId]);

  // 🔹 Loading State
  if (loading) {
    return (
      <div className="dashbaord-bg py-20 text-center">
        Loading invoice...
      </div>
    );
  }

  // 🔹 Not Found
  if (!invoice) {
    return (
      <div className="dashbaord-bg py-20 text-center">
        Invoice not found
      </div>
    );
  }
  const statusOptions = [
    { label: "Pending", value: "pending" },
    { label: "Delivered", value: "delivered" },
    { label: "Paid", value: "paid" },
  ];
  const handleStatusChange = async (newStatus) => {
    try {
      const resp = await updateInvoiceStatus({
        o_id: invoice._id,
        status: newStatus,
      });


      if (resp.success) {
        setInvoice((prev) => ({
          ...prev,
          status: newStatus,
        }));

        Swal.fire({
          icon: "success",
          text: "Status updated successfully",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: "Failed to update status",
      });
    }
  };

  return (
    <div className="dashbaord-bg py-10">
      <div className="container">

        {/* Header */}
        <div className="border-b border-gray-200 pb-[15px] mb-[30px] flex items-center justify-between flex-wrap gap-[15px]">
          <h1 className="headings-h1 text-zinc-950">Invoice</h1>
        </div>

        <div className="flex flex-col gap-[15px] md:gap-[30px]">

          {/* Invoice Header */}
          <div className="flex items-start justify-between">
            <div className="flex flex-col gap-[5px]">
              <h2 className="headings-h5 text-zinc-950">
                #{invoice.invoice_number}
              </h2>
              <p className="body-md text-zinc-500">
                {moment(invoice.invoice_date).format("MMMM DD, YYYY")}
              </p>
            </div>
            {/* <select
              className="form-control-custom max-w-[130px]"
              value={invoice.status || ""}
              onChange={(e) => handleStatusChange(e.target.value)}
            >
              {statusOptions.map((status) => (
                <option key={status.value} value={status.value}>
                  {status.label}
                </option>
              ))}
            </select> */}


          </div>

          {/* Seller Details */}
          <div className="p-[15px] bg-white rounded-[10px] border-1 !border-zinc-100 shadow-[0px_2px_24px_rgba(0,0,0,0.05)]">
            <h3 className="headings-h5 text-zinc-950 mb-2">Seller Details</h3>

            <p className="body-md text-zinc-500">
              <span className="font-medium text-zinc-950">Name:</span>{" "}
              {invoice.seller?.name || "-"}
            </p>

            <p className="body-md text-zinc-500">
              <span className="font-medium text-zinc-950">Address:</span>{" "}
              {invoice.seller?.address || "-"}
            </p>
          </div>

          {/* Billing & Shipping */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

            {/* Billing */}
            <div className="p-[15px] bg-white rounded-[10px] border-1 !border-zinc-100 shadow-[0px_2px_24px_rgba(0,0,0,0.05)]">
              <h4 className="headings-h5 text-zinc-950 mb-2">
                Billing Address
              </h4>

              <p className="body-md text-zinc-500 font-medium">
                {invoice.customer?.name || "-"}
              </p>

              <p className="body-md text-zinc-500">
                {invoice.billing_address || "-"}
              </p>
            </div>

            {/* Shipping */}
            <div className="p-[15px] bg-white rounded-[10px] border-1 !border-zinc-100 shadow-[0px_2px_24px_rgba(0,0,0,0.05)]">
              <h4 className="headings-h5 text-zinc-950 mb-2">
                Shipping Address
              </h4>

              <p className="body-md text-zinc-500 font-medium">
                {invoice.customer?.name || "-"}
              </p>

              <p className="body-md text-zinc-500">
                {invoice.shipping_address || "-"}
              </p>
            </div>
          </div>

          {/* Items Section */}
          <div className="bg-gray-100 rounded-[10px] p-[10px]">

            {/* Table Header */}
            <div className="grid grid-cols-4 font-semibold text-gray-700 mb-2">
              <div className="col-span-2 headings-h4 text-zinc-950">Item</div>
              <div className="headings-h4 text-zinc-950">Qty</div>
              <div className="text-right headings-h4 text-zinc-950">Price</div>
            </div>

            {/* Items List */}
            {invoice.items?.map((item, index) => (
              <div key={index} className="grid grid-cols-4 text-gray-600 py-2">
                <div className="col-span-2 body-lg text-slate-600">
                  {item.product_name}
                </div>
                <div className="body-lg text-slate-600">
                  {item.quantity}
                </div>
                <div className="text-right body-lg text-slate-600">
                  INR {(item.price * item.quantity).toFixed(2)}
                </div>
              </div>
            ))}

          </div>

          {/* Total */}
          <div className="flex flex-col gap-[15px]">
            <h2 className="headings-h2 text-zinc-950">
              Total: INR {invoice.total_amount}
            </h2>

            {/* <button className="btn btn-pri w-[fit-content]">
              Save & Send
            </button> */}
          </div>

        </div>
      </div>
    </div>
  );
}

export default InvoiceDetail;
